import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DemoService } from './../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { enableRipple } from '@syncfusion/ej2-base';
import { HttpClient } from '@angular/common/http';
import { LegalDateTimeService } from 'src/app/services/legal-datetime.service';

enableRipple(true);

@Component({
  selector: 'app-metric-chart-multi-series-staff-user-multiple-axis',
  templateUrl: './metric-chart-multi-series-staff-user-multiple-axis.component.html',
  styleUrls: ['./metric-chart-multi-series-staff-user-multiple-axis.component.scss']
})
export class MetricChartMultiSeriesStaffUserMultipleAxisComponent implements OnInit, OnChanges {
  @Input() item_data?: any[];             // Main log data
  @Input() item_data2?: any[];            // Data containing user_logs_array entries
  @Input() use_item_data? = 'no';
  @Input() item_user_level_id? = '5';
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no';
  @Input() widget_title? = '';
  @Input() widget_size? = 'side';

  public series: any[] = [];              // Holds the log count series data
  public benchmarkSeries: any[] = [];      // Holds the benchmark data series
  public xLabels: string[] = [];           // X-axis labels (days of the week)
  public chartArea: Object = { border: { width: 0 } };
  public tooltip: Object = { enable: true };
  public legend: Object = { visible: true };
  public title: string = 'Log Actions by Day';
  public log_types: { [key: string]: any } = {}; // Holds log type mappings
  public loading = true;                   // Loading state
  user_productivity: any[];
  zoom: { enableSelectionZooming: boolean; enablePan: boolean; mode: string; enableAnimation: boolean; };
  animation: { enable: boolean; };

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private _demoService: DemoService,
    public datepipe: DatePipe,
    public toastr: HotToastService,
    public legalDate: LegalDateTimeService,
  ) {

    this.legend = {
      visible: false,
      position: 'Bottom',
    };

  }

  ngOnInit(): void {
    this.getSystemLogTypes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item_data'] || changes['item_data2']) {
      this.loading = true;
      this.processData();
    }
  }

  private processData(): void {
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const logCountByDay: { [day: string]: { [logTypeId: string]: number } } = {}; // Holds log counts by day
    const benchmarkData: { [logTypeName: string]: any[] } = {};                  // Holds benchmark data by log type

    // Initialize log counts to 0 for each day of the week
    daysOfWeek.forEach(day => {
      logCountByDay[day] = {};
      Object.keys(this.log_types).forEach(logTypeId => {
        logCountByDay[day][logTypeId] = 0;
      });
    });

    // Process `item_data` to count logs by day and type
    if (this.item_data) {
      this.item_data.forEach(log => {
        const date = this.legalDate.toAuditDate(log.created_date);
        if (!date || isNaN(date.getTime())) return;  // Skip invalid dates
        const dayName = this.legalDate.formatAudit(date, 'dddd');

        // Increment the count for each log type and day
        if (logCountByDay[dayName] && this.log_types[log.log_type_id]) {
          logCountByDay[dayName][log.log_type_id]++;
        }
      });
    }

    // Process `user_logs_array` within `item_data2` for benchmark data
    if (this.item_data2) {
      this.item_data2.forEach(user => {
        if (user.user_logs_array && user.user_logs_array.length > 0) {
          user.user_logs_array.forEach(logEntry => {
            if (user.reporting_calendar?.target_weekday_counts) {
              benchmarkData[logEntry.log_type_name] = daysOfWeek.map((day, index) => ({
                x: day.substring(0, 3),
                y4: (Number(logEntry.unit_per_day) || 0) * user.reporting_calendar.target_weekday_counts[index]
              }));
              return;
            }
            // Convert `benchmark_duration` from ms to days
           
           
            let durationInDays = user.Duration / (1000 * 60 * 60 );
            console.log('durationInDays ' + durationInDays)

            let days_duration_range = 7
            if(durationInDays <= 6 && durationInDays > 1 ){
              days_duration_range = durationInDays * durationInDays ; // then devide by seven
            }
            if(durationInDays <= 1 ){ // less than a day than the couts are correct.
              days_duration_range = durationInDays
            }



            // const durationInDays2 = (logEntry.benchmark_duration / durationInDays);
            let durationInDays2 = logEntry.benchmark_duration;

            // Initialize benchmark data for each log_type_name across all days of the week
            if (!benchmarkData[logEntry.log_type_name]) {
              benchmarkData[logEntry.log_type_name] = daysOfWeek.map(day => ({
                x: day.substring(0, 3),  // Abbreviated day name
                y4: durationInDays2 / days_duration_range   // Benchmark value in days // if days less than 7 // divide by the days duration...../// thats the one!!!
              }));
            }
          });
        }
      });
    }

    // Create log count series for the chart using `item_data`
    this.series = Object.keys(this.log_types).map(logTypeId => ({
      name: this.log_types[logTypeId].log_type_name,
      data: daysOfWeek.map(day => ({
        x: day.substring(0, 3),             // Abbreviated day name
        y: logCountByDay[day][logTypeId] || 0  // Log count or 0 if none
      })),
      yAxisName: 'primary'
    }));


    // This produces the current user/s selected in search model item_data 2 counts
    // Filter only the users with a non-empty `user_logs_array` and map the filtered list
    this.user_productivity = this.item_data2
    .filter(user2 => user2.user_logs_array && user2.user_logs_array.length > 0) // Only users with non-empty user_logs_array
    .map(user2 => ({
    ...user2 // Spread the user object to keep its properties
    }));


    // Create benchmark series for the chart using `user_logs_array` from `item_data2`
    this.benchmarkSeries = Object.keys(benchmarkData).map(logTypeName => ({
      name: `${logTypeName}`,
      data: benchmarkData[logTypeName]
    }));

    
    this.zoom = {
      enableSelectionZooming: true,
      enablePan: true,
      mode: 'XY',
      enableAnimation: true
      };
      this.animation = { enable: false};
    
    
    // Set X-axis labels as abbreviated day names
    this.xLabels = daysOfWeek.map(day => day.substring(0, 3));
    this.loading = false;



  }

  getSystemLogTypes() {
    if (Object.keys(this.log_types).length) return; // Avoid re-fetching if log_types already loaded

    this._demoService.getSystemLogTypesWithBenchmarksStaff().subscribe(
      (data: any[]) => {
        if (Array.isArray(data)) {
          this.log_types = data.reduce((acc: any, logType: any) => {
            acc[logType.log_type_id] = logType;
            return acc;
          }, {});
        } else {
          console.error('Expected array, received:', data);
        }
      },
      err => console.error('Error fetching log types:', err),
      () => console.log('System Log Types loaded')
    );
  }
}
